import BaseUpdateRequest from "../Shared/BaseUpdateRequest";

export default class PlaceJobWorkerOfferRequest extends BaseUpdateRequest {
    jobWorkerOfferId: string;
    startDate: string;
    fee = 0;
}